import sequentialPromiseProcessor from "./sequentialPromiseProcessor";

export default {
  sequentialPromiseProcessor,
};
